import { FontPairingStyle } from 'constants/fontPairings'
import { FontRole } from 'types'
import Styles from './BrandKitFonts.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { BrandKitFontPicker } from './BrandKitFontPicker/BrandKitFontPicker'
import { BrandKitFontsProps } from './Types'

export const BrandKitFonts = ({ fontPairing, onFontPairingChange, fontPairingState }: BrandKitFontsProps) => {
  // Extract brand kit font families from the fontPairingState if available
  const brandKitFontFamilies = fontPairingState.websitePairing
    ? [
        fontPairingState.websitePairing[0].style.font_family,
        fontPairingState.websitePairing[1].style.font_family,
      ].filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
    : []

  const titleFontSize = 24 // Always 24 for titles
  const bodyFontSize = 16 // Always 16 for body

  return (
    <div className={Styles.brandKitFonts}>
      <div className={Styles.header}>
        <Heading level={4}>Pick your fonts</Heading>
        <Text variant="metadata" color="var(--dark-60)">
          We will use them to make your posts and marketing materials look awesome.
        </Text>
      </div>
      <div className={Styles.fontSelectorWithLabel}>
        <Text variant="label" color="var(--dark-40)">
          Headline
        </Text>
        <BrandKitFontPicker
          aria-label="Headline font"
          selectedFontFamily={fontPairing[0]?.style.font_family}
          selectedWeight={fontPairing[0]?.style.font_weight}
          selectedFontSize={titleFontSize}
          defaultFontSize={24}
          brandKitFontFamilies={brandKitFontFamilies}
          size="sm"
          onSelectionChange={(fontFamily, weight, fontSize, availableWeights) => {
            const newFontStyle: FontPairingStyle<FontRole.Title> = {
              font_role: FontRole.Title,
              style: {
                font_family: fontFamily as string,
                font_weight: weight,
                font_size: fontSize,
                italic: false,
                line_height: 1,
                letter_spacing: -40,
              },
            }

            onFontPairingChange([newFontStyle, fontPairing[1]])
          }}
        />
      </div>
      <div className={Styles.fontSelectorWithLabel}>
        <Text variant="label" color="var(--dark-40)">
          Body
        </Text>
        <BrandKitFontPicker
          aria-label="Body font"
          selectedFontFamily={fontPairing[1]?.style.font_family}
          selectedWeight={fontPairing[1]?.style.font_weight}
          selectedFontSize={bodyFontSize}
          defaultFontSize={16}
          brandKitFontFamilies={brandKitFontFamilies}
          size="sm"
          onSelectionChange={(fontFamily, weight, fontSize, availableWeights) => {
            const newFontStyle: FontPairingStyle<FontRole.Body> = {
              font_role: FontRole.Body,
              style: {
                font_family: fontFamily as string,
                font_weight: weight,
                font_size: fontSize,
                italic: false,
                line_height: 1.2,
                letter_spacing: -10,
              },
            }

            onFontPairingChange([fontPairing[0], newFontStyle])
          }}
        />
      </div>
    </div>
  )
}
